module.exports = __webpack_public_path__ + "img/map-4.1e1debfe.jpg";